import './pendingPracticeInvitationStep.scss';

import { RadioGroupEditor } from '@approvalmax/ui';
import { constants } from 'modules/common';
import { domain } from 'modules/data';
import { components } from 'modules/profile';
import { FC, memo, useEffect, useMemo } from 'react';
import bemFactory from 'react-bem-factory';

import { messages } from './PendingPracticeInvitationStep.messages';

const bem = bemFactory.block('pending-practice-invitation-step');
const qa = bemFactory.qa('pending-practice-invitation-step');

interface PendingPracticeInvitationStepProps {
    onSelectOption: (option: string) => void;
    value: string | null;
    invitations: domain.PracticeInvitation[];
}

const PendingPracticeInvitationStep: FC<PendingPracticeInvitationStepProps> = (props) => {
    const { onSelectOption, value, invitations } = props;

    const firstInvitation = useMemo(() => {
        if (value) {
            return value;
        }

        return invitations[0]?.id || '';
    }, [invitations, value]);

    useEffect(() => {
        onSelectOption(firstInvitation);
    }, [firstInvitation, onSelectOption]);

    return (
        <div className={bem()} data-qa={qa()}>
            <div className={bem('business-accounts-text')}>{messages.followingBusinessAccountsText}</div>

            <div className={bem('what-happend-after-accepting-text')}>{messages.whatHappenedAfterAcceptingText}</div>

            <RadioGroupEditor value={firstInvitation} onChange={onSelectOption}>
                {invitations.map((item) => (
                    <components.PracticeInvitationRow className={bem('radio_item')} key={item.id} item={item} />
                ))}

                <RadioGroupEditor.Item
                    className={bem('radio_item', 'decline')}
                    id={constants.commonConstants.DECLINE_ALL_INVITATIONS_OPTION}
                >
                    {messages.declineAllInvitations}
                </RadioGroupEditor.Item>
            </RadioGroupEditor>
        </div>
    );
};

export default memo(PendingPracticeInvitationStep);
